module.exports = __webpack_public_path__ + "img/DW365-153.dd03b64e.jpg";